import React from 'react';

const SvgChevronDown = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.5 8.775L12.001 16.5 5.5 8.775 6.959 7.5 12 13.489l5.04-5.988z",
  fillRule: "evenodd"
}));

export default SvgChevronDown;